import { all, call, put, select } from 'redux-saga/effects';
import {
  addDocumentFolderResponse,
  addDocumentsToFolderResponse,
  deleteDocumentFolderResponse,
  fetchDocumentFoldersResponse,
  setActiveDocumentFolderResponse,
  updateDocumentFolderResponse
} from '../actions/documents';
import { getActiveCompany } from '../selectors/company';
import customToast from '../utils/customToast';

export function* fetchDocumentsByFolder(apiV4, { payload }) {
  try {
    yield put(setActiveDocumentFolderResponse(payload));
  } catch (e) {
    customToast(e, 'error');
  }
}

export function* fetchDocumentFolders(apiV4, { payload }) {
  try {
    const response = yield call(
      apiV4.fetchDocumentFoldersByType,
      payload.documentType
    );

    yield put(fetchDocumentFoldersResponse(response));
  } catch (e) {
    customToast(e, 'error');
  }
}

export function* addDocumentFolder(apiV4, { payload }) {
  try {
    const activeCompany = yield select(getActiveCompany);

    payload = {
      ...payload,
      companyId: activeCompany._id
    };

    const response = yield call(apiV4.createDocumentFolder, payload);
    yield put(addDocumentFolderResponse(response));
    customToast('Successfully Saved!', 'success');
    const newSet = yield call(
      apiV4.fetchDocumentFoldersByType,
      payload.documentType
    );
    yield put(fetchDocumentFoldersResponse(newSet));
  } catch (e) {
    customToast(e, 'error');
  }
}

export function* updateDocumentFolder(apiV4, { payload }) {
  try {
    const response = yield call(apiV4.updateDocumentFolder, payload);

    yield put(updateDocumentFolderResponse(response));
    yield put(setActiveDocumentFolderResponse(response));
    customToast('Successfully Updated!', 'success');
  } catch (e) {
    customToast(e, 'error');
  }
}

export function* deleteDocumentFolder(apiV4, { payload }) {
  try {
    const documents = payload.documents;
    let documentIds = documents?.map(d => d._id);
    delete payload.documents;

    if (payload.deleteAll) {
      delete payload.deleteAll;

      if (payload.documentType === 'SafetyTraining') {
        yield all(
          documents.map(document => call(apiV4.deleteTraining, document))
        );
      } else if (payload.documentType === 'TrainingCourses') {
        yield call(apiV4.deleteManyTrainingCourses, documentIds);
      } else {
        yield call(apiV4.deleteManyDocuments, {
          documentIds
        });
      }

      yield call(apiV4.deleteDocumentFolder, payload?._id);
    } else {
      delete payload.deleteAll;

      if (payload.documentType === 'SafetyTraining') {
        yield all(
          documents.map(document =>
            call(apiV4.updateTraining, { ...document, documentFolderId: '' })
          )
        );
      } else {
        let documentIds = documents?.map(d => d._id);
        yield call(apiV4.updateManyDocuments, {
          documentIds,
          documentFolderId: ''
        });
      }

      yield call(apiV4.deleteDocumentFolder, payload?._id);
    }

    yield put(deleteDocumentFolderResponse(payload));
    yield put(setActiveDocumentFolderResponse({}));
    customToast('Successfully Deleted!', 'success');
  } catch (e) {
    customToast(e, 'error');
  }
}

export function* addDocumentsToFolder(apiV4, { payload }) {
  try {
    if (payload.type === 'documents') {
      yield call(apiV4.updateManyDocuments, {
        documentIds: payload.documents,
        documentFolderId: payload.documentFolderId
      });

      customToast('Successfully Saved!', 'success');
    } else {
      yield all(
        payload.documents.map(document =>
          payload.documentType === 'SafetyTraining'
            ? call(apiV4.updateTraining, {
                _id: document._id,
                documentFolderId: payload.documentFolderId,
                fromAddFolder: true
              })
            : payload.documentType === 'Repeating'
              ? call(apiV4.updateTrainingRepeatable, {
                  _id: document._id,
                  type: 'trainings',
                  documentFolderId: payload.documentFolderId,
                  fromAddFolder: true
                })
              : call(apiV4.updateTrainingScanOnDemand, {
                  _id: document._id,
                  type: 'trainings',
                  documentFolderId: payload.documentFolderId,
                  fromAddFolder: true
                })
        )
      );
    }
    yield put(addDocumentsToFolderResponse());
  } catch (e) {
    customToast(e, 'error');
  }
}
